export const UNITE_LANGUAGE_KEY = 'ui_language_code'
export const UNITE_DEVELOPMENT = 'unite_development'
export const UNITE_CALL_SERVER_VERSION = 'call_server_version'
export const DEV_LOGIN_DATA_KEY = 'dev_login_data'
export const N2P_STORAGE = 'n2p'
export const DIALER_OPEN_KEY = 'dialerOpen'

export const getFromStorage = (key) =>
  localStorage.getItem(key) || sessionStorage.getItem(key)
export const setStorage = (key, value) => {
  const storage =
    sessionStorage.getItem(key) === 'null' ? sessionStorage : localStorage

  storage.setItem(key, value)
}
export const removeFromStorage = (key) => {
  localStorage.removeItem(key)
  sessionStorage.removeItem(key)
}
/**
 * @param {string} key
 * @param {null | boolean} fallbackValue
 * @returns {any}
 */
export const getStorageJSON = (
  key = UNITE_DEVELOPMENT,
  fallbackValue = null,
) => {
  const value = localStorage.getItem(key)
  if (value === null && fallbackValue !== undefined) {
    return fallbackValue
  }
  return JSON.parse(value || '{}')
}
export const setStorageJSON = (key = UNITE_DEVELOPMENT, value) => {
  localStorage.setItem(key, JSON.stringify(value))
  return value
}
export const addStorageJSON = (key = UNITE_DEVELOPMENT, value) => {
  setStorageJSON(key, { ...getStorageJSON(key), ...value })
  return getStorageJSON()
}
